import * as D from "@radix-ui/react-dialog";
import clsx from "clsx";
import { useRef, type ReactNode } from "react";
import { IconButton } from "./IconButton";
import { Close } from "./icons";
import s from "./Dialog.module.css";

export interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  size?: "md" | "lg";
  children: ReactNode;
}

export function Dialog({ open, onOpenChange, title, description, size = "md", children }: DialogProps) {
  const body = useRef<HTMLDivElement>(null);
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className={s.overlay} />
        <D.Content
          className={clsx(s.content, s[size])}
          // Focus the body, not the close button: focusing the button would open its tooltip and the first Esc would only close the tooltip.
          onOpenAutoFocus={(e) => {
            e.preventDefault();
            body.current?.focus();
          }}
        >
          <header className={s.header}>
            <D.Title className={s.title}>{title}</D.Title>
            <D.Close asChild>
              <IconButton label="Close" shortcut="Esc" icon={<Close />} size="sm" />
            </D.Close>
          </header>
          {description ? <D.Description className={s.description}>{description}</D.Description> : <D.Description className="df-visually-hidden">{title}</D.Description>}
          <div ref={body} className={s.body} tabIndex={-1}>
            {children}
          </div>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
